export default {
    addViewedOffer: ({ commit }, payload) => commit('ADD_VIEWED_OFFER', payload)
};
